import { COMPARISON_PAGE_SLUGS } from './comparison-page-routes.generated';
import { MARKETING_PAGE_REDIRECT_SLUGS } from './marketing-page-redirects';
import { MARKETING_PAGE_SLUGS } from './marketing-page-routes.generated';
import { MARKETING_PRO_PAGE_SLUGS } from './marketing-pro-page-routes.generated';
import { KNOWN_TOP_LEVEL_ROUTES } from './routes';

const EXTRA_RESERVED_ROOT_SEGMENTS = [
  'home',
  'wls',
  'share',
  'unsubscribe',
  'imported',
  'opt-out',
  'bio',
  'login',
  'signup',
  'pro',
  'apps'
] as const;

function firstPathSegment(slug: string): string {
  return (slug || '').split('/').filter(Boolean)[0] || '';
}

const RESERVED_FRONT_URL_SEGMENTS = new Set<string>([
  ...KNOWN_TOP_LEVEL_ROUTES,
  ...EXTRA_RESERVED_ROOT_SEGMENTS,
  ...MARKETING_PAGE_SLUGS.map((slug) => firstPathSegment(slug).toLowerCase()),
  ...MARKETING_PAGE_REDIRECT_SLUGS.map((slug) => firstPathSegment(slug).toLowerCase()),
  ...COMPARISON_PAGE_SLUGS.map((slug) => firstPathSegment(slug).toLowerCase()),
  ...MARKETING_PRO_PAGE_SLUGS.map((slug) => firstPathSegment(slug).toLowerCase())
]);

export function isReservedFrontUrlSegment(
  segment: string,
  extraSlugs: readonly string[] = []
): boolean {
  const normalized = (segment || '').trim().toLowerCase();
  if (!normalized) {
    return false;
  }
  if (RESERVED_FRONT_URL_SEGMENTS.has(normalized)) {
    return true;
  }
  return extraSlugs.some(
    (slug) => firstPathSegment(slug).toLowerCase() === normalized
  );
}
